// Kamana Yoga Farbpalette - Kamana Pink
export const DARK_MODE_COLORS = {
  // Primärfarben - Kamana Pink
  primary: '#e80c7f',        // Kamana Pink Hauptfarbe
  primaryHover: '#d00b72',   // Dunkleres Kamana Pink
  
  // Akzentfarben - Kamana Pink Varianten
  accent: '#e80c7f',         // Kamana Pink
  accentYellow: '#f5429e',   // Helles Kamana Pink
  accentDark: '#c00a6b',     // Dunkles Kamana Pink
  
  // Text - Mehr Kontrast für Dark Mode
  textPrimary: '#E0E0E0',    // Helles Grau für besseren Kontrast
  textSecondary: '#B0B0B0',   // Mittelgrau
  textMuted: '#888888',      // Dunkleres Grau
  
  // Hintergründe - Modern einfarbig dunkel
  bg: '#1a1a1a',
  bgImage: '',
  bgCard: 'rgba(30, 30, 30, 0.8)',
  bgCardHover: 'rgba(40, 40, 40, 0.9)',
  
  // Header
  headerBg: 'rgba(26, 26, 26, 0)',
  headerBgMobile: 'rgba(26, 26, 26, 0.95)',
  headerBorder: 'rgba(232, 12, 127, 0.3)',
};

export const LIGHT_MODE_COLORS = {
  // Primärfarben - Kamana Pink
  primary: '#e80c7f',        // Kamana Pink Hauptfarbe
  primaryHover: '#d00b72',   // Dunkleres Kamana Pink
  
  // Akzentfarben - Kamana Pink Varianten
  accent: '#e80c7f',         // Kamana Pink
  accentYellow: '#f5429e',   // Helles Kamana Pink
  accentDark: '#c00a6b',     // Dunkles Kamana Pink
  
  // Text - Dunkles Anthrazit
  textPrimary: '#333333',    // Anthrazit
  textSecondary: '#666666',  // Dunkelgrau
  textMuted: '#8A8A8A',      // Mittelgrau
  
  // Hintergründe - Modern einfarbig hell
  bg: '#FAFAFA',
  bgImage: '',
  bgCard: 'rgba(255, 255, 255, 0.9)',
  bgCardHover: 'rgba(250, 250, 250, 1)',
  
  // Header
  headerBg: 'rgba(250, 250, 250, 0)',
  headerBgMobile: 'rgba(250, 250, 250, 0.95)',
  headerBorder: 'rgba(232, 12, 127, 0.2)',
};

// Dynamic colors based on theme
export const getColors = (isDark: boolean) => isDark ? DARK_MODE_COLORS : LIGHT_MODE_COLORS;

